
import { css } from '@emotion/core'
import { screenSmall } from 'components/utils/screen-sizes'

export const mainPageContentLayoutCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  // Footer + header height: 214 + 72 = 286
  min-height: calc(100vh - 286px);

  @media (max-width: ${screenSmall}) {
    min-height: calc(100vh - 400px);
  }
`

export const mainPageContentCss = css`
  max-width: 44.875rem;
  padding: 0 1rem;
`
